import { Form, Formik } from 'formik';
import React, { useEffect, useRef, useState } from 'react';
import * as Yup from 'yup';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { AppSnackbar } from '@sierralabs/core-ui';
import { FormikCheckboxField, FormikGrid, FormikTextField } from '@sierralabs/react-material-ui-formik';
import { useCreateReport } from '../hooks/useCreateReport';
import { useUpdateReport } from '../hooks/useUpdateReport';
export const SaveReportDialog = props => {
    var _a;
    const { open, report, queryConfig, onCancel, onSave } = props;
    const formikRef = useRef(null);
    const onSaveRef = useRef(onSave);
    onSaveRef.current = onSave;
    const [error, setError] = useState();
    const { createdReport, creatingReport, creatingReportError, createReport } = useCreateReport();
    const { updatedReport, updatingReport, updatingReportError, updateReport } = useUpdateReport((report === null || report === void 0 ? void 0 : report.id) || 0);
    const isLoading = creatingReport || updatingReport;
    useEffect(() => {
        var _a;
        (_a = formikRef.current) === null || _a === void 0 ? void 0 : _a.setSubmitting(isLoading);
    }, [isLoading]);
    useEffect(() => {
        var _a;
        if (createdReport) {
            (_a = onSaveRef.current) === null || _a === void 0 ? void 0 : _a.call(onSaveRef, createdReport);
        }
    }, [createdReport]);
    useEffect(() => {
        var _a;
        if (updatedReport) {
            (_a = onSaveRef.current) === null || _a === void 0 ? void 0 : _a.call(onSaveRef, updatedReport);
        }
    }, [updatedReport]);
    useEffect(() => {
        creatingReportError && setError(creatingReportError);
    }, [creatingReportError]);
    useEffect(() => {
        updatingReportError && setError(updatingReportError);
    }, [updatingReportError]);
    return (React.createElement(Dialog, { fullWidth: true, maxWidth: 'xs', open: open, onClose: () => {
            if (!isLoading) {
                onCancel === null || onCancel === void 0 ? void 0 : onCancel();
            }
        } },
        React.createElement(Formik, { innerRef: formikRef, initialValues: {
                name: (report === null || report === void 0 ? void 0 : report.query.name) || '',
                shared: (_a = report === null || report === void 0 ? void 0 : report.shared) !== null && _a !== void 0 ? _a : false
            }, validationSchema: Yup.object({
                name: Yup.string().required('Required'),
                shared: Yup.boolean()
            }), onSubmit: values => {
                if (report) {
                    report.query.name = values.name;
                    report.query.config = queryConfig;
                    report.shared = values.shared;
                    updateReport(report);
                }
                else if (queryConfig) {
                    createReport({
                        name: values.name,
                        shared: values.shared,
                        queryConfig
                    });
                }
            } }, formik => (React.createElement(Form, { autoComplete: 'off' },
            React.createElement(DialogTitle, null, report ? 'Update Report' : 'New Report'),
            React.createElement(DialogContent, null,
                React.createElement(FormikGrid, null,
                    React.createElement(FormikTextField, { autoFocus: true, type: 'text', name: 'name', label: 'Report Name' }),
                    React.createElement(FormikCheckboxField, { name: 'shared', label: 'Share with other team members.' }))),
            React.createElement(DialogActions, null,
                React.createElement(Button, { disabled: formik.isSubmitting, onClick: onCancel }, "Cancel"),
                React.createElement(Button, { type: 'submit', color: 'primary', variant: 'contained', disabled: !formik.isValid || formik.isSubmitting, endIcon: formik.isSubmitting && (React.createElement(CircularProgress, { color: 'primary', size: 20 })) }, report ? 'Update' : 'Create'))))),
        React.createElement(AppSnackbar, { severity: 'error', open: !!error, onClose: () => setError(undefined) }, (error === null || error === void 0 ? void 0 : error.message) || 'An error occurred.')));
};
export default SaveReportDialog;
//# sourceMappingURL=SaveReportDialog.js.map